import { PaywallInformation } from "../model/PaywallModel";
import { Api } from "./api";

export async function verifyUsers(internalName: string) {
    const response = await Api.get<PaywallInformation>(`paywall/VerifyUsers/${internalName}`);
    return response.data;
}

export async function verifyWorkpace(internalName: string, workspaceId?: string) {
    const response = await Api.get<PaywallInformation>(`paywall/VerifyWorkspaces/${internalName}?workspaceId=${workspaceId}`);
    return response.data;
}